import { createFileRoute, redirect } from "@tanstack/react-router";

// Security is the only section that exists yet, so /settings is just a way in.
export const Route = createFileRoute("/dashboard/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/settings/security" });
  },
});
